import { defineStore } from 'pinia';
import type { SettingsStore } from '@/types/settings';

export function initSettings(locale: string) {
  let store = JSON.parse(localStorage.getItem('settings') as string) as SettingsStore;
  if (store == null) {
    store = {
      sideBarVisible: false,
      locale: locale,
      darkMode: false
    };
    localStorage.setItem('settings', JSON.stringify(store));
  }
}

export const useSettingsStore = defineStore('settings', {
  state: (): SettingsStore => (JSON.parse(localStorage.getItem('settings') as string)),
  actions: {
    setDarkMode: function(darkMode: boolean) {
      const store = JSON.parse(localStorage.getItem('settings') as string) as SettingsStore;
      store.darkMode = darkMode;
      localStorage.setItem('settings', JSON.stringify(store));
    },
    setSideBarVisible: function(sideBarVisible: boolean) {
      const store = JSON.parse(localStorage.getItem('settings') as string) as SettingsStore;
      store.sideBarVisible = sideBarVisible;
      localStorage.setItem('settings', JSON.stringify(store));
    },
    setLocale: function(locale: string) {
      const store = JSON.parse(localStorage.getItem('settings') as string) as SettingsStore;
      store.locale = locale;
      localStorage.setItem('settings', JSON.stringify(store));
    }
  },
  getters: {
    isDarkModeEnabled: (state: SettingsStore): boolean => {
      return state.darkMode;
    },
    getLocale: (state: SettingsStore): string => {
      return state.locale;
    },
    isSideBarVisible: (state: SettingsStore): boolean => {
      return state.sideBarVisible;
    }
  }
});
